//import { Test } from './Test';
import { Source } from './Source';
export class User {
  Id: string ="";
  FirstName: string = "";
  LastName: string = "";
  Email: string = "";
  Tel: string ="";
  //Tests: Test[];
  Site: number = 0;
  Sources: Source[] = [];
  Clinician: string = "";
  IsPasswordNeedReset: boolean = false;
  TwoFactorEnabled: boolean = false;
  HasAcceptedTandC: boolean = false;
  CanViewResults: boolean = false;
  CanOrderKits: boolean = false;
  CanSeeAllSiteResults: boolean = false;
  CanRequest: boolean = false;
}
